// Generated from api/openapi/admin.yaml by make docs. Do not edit.
import { z } from "zod";

export const destinationScopeSchema = z.object({
  "group_id": z.string().uuid(),
  "destination_cidr": z.string().min(1),
  "protocol": z.enum(["ssh", "sftp", "rdp"]),
  "port": z.number().int().min(1).max(65535),
  "account": z.string().min(1)
});
